(function () {
  'use strict';

  /* mobile menu */
  var menuBtn = document.getElementById('menuBtn');
  var menu = document.getElementById('menu');
  if (menuBtn && menu) {
    menuBtn.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
  }

  /* tabs */
  document.querySelectorAll('[data-tabs]').forEach(function (list) {
    var root = list.closest('section');
    var tabs = [].slice.call(list.querySelectorAll('[role="tab"]'));
    function show(i) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        var p = root.querySelector('[data-panel="' + j + '"]');
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
          show(n);
          tabs[n].focus();
        }
      });
    });
  });

  /* plan picker + buy button (adds the chosen product, then goes to checkout) */
  document.querySelectorAll('[data-scope]').forEach(function (scope) {
    var radios = [].slice.call(scope.querySelectorAll('input[type="radio"][data-variant]'));
    var total = scope.querySelector('[data-total]');
    var buy = scope.querySelector('[data-buy]');
    var status = scope.querySelector('[data-status]');

    function sync() {
      radios.forEach(function (r) {
        var card = r.closest('.plan');
        if (card) card.classList.toggle('on', r.checked);
      });
      var sel = radios.filter(function (r) { return r.checked; })[0];
      if (sel && total) total.textContent = sel.getAttribute('data-money');
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();

    if (!buy) return;
    buy.addEventListener('click', function () {
      var sel = radios.filter(function (r) { return r.checked; })[0];
      if (!sel) { if (status) status.textContent = 'Please choose an option first.'; return; }
      var label = buy.textContent;
      buy.disabled = true;
      buy.textContent = 'One moment...';
      if (status) status.textContent = '';
      var post = function (url, body) {
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: body ? JSON.stringify(body) : '{}'
        });
      };
      post(window.theme.routes.cart_clear)
        .then(function () { return post(window.theme.routes.cart_add, { items: [{ id: Number(sel.value), quantity: 1 }] }); })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); window.location.href = window.theme.routes.checkout; })
        .catch(function () {
          buy.disabled = false;
          buy.textContent = label;
          if (status) status.textContent = 'Sorry, something went wrong. Please try again.';
        });
    });
  });
})();
